<div [ngClass]="{'inline': inlineLabel}">
    <label class="atom-label" [ngClass]="labelClass" [ngStyle]="labelStyle">{{ label }}</label>
    <ng-container *ngIf="!hasHyperlinkValue;else withHyperlink">
        <ng-container *ngTemplateOutlet="withouthHyperlink"></ng-container>
    </ng-container>
</div>

<ng-template #withouthHyperlink>
    <p class="value" [ngClass]="valueClass" [ngStyle]="valueStyle">{{ displayValue }}</p>
</ng-template>
<ng-template #withHyperlink>
    <ng-container *ngIf="useSplitHyperlinkValue; else fullHyperlink">
        <p class="value" [ngClass]="valueClass" [ngStyle]="valueStyle">
            <strong *ngIf="valuePrefixBold; else normalPrefix">{{ displayValuePrefix }}</strong>
            <ng-template #normalPrefix><span>{{ displayValuePrefix }}</span></ng-template>
            <a class="value-link" (click)="hyperlinkClick($event)">{{ displayValueLink }}</a>
            <span>{{ displayValueSuffix }}</span>
        </p>
    </ng-container>
    <ng-template #fullHyperlink>
        <a class="value" [ngClass]="valueClass" [ngStyle]="valueStyle"
           (click)="hyperlinkClick($event)">{{ displayValue }}</a>
    </ng-template>
</ng-template>
